<template>
  <div>
    <div class="login" :style='backgroundType' style='background-size: 100% 100%;'>
      <div class="loginHeader">
        <span><img :src="logo"></span>
      </div>
      <!--      绿云钉直接选择酒店-->
      <template v-if="showSelectHotel">
        <div class="hotel-list">
          <div class="hotel-list-item"
               @click="selectHotel(item)"
               :class="{active: currentHotel.unitCode == item.unitCode}"
               v-for="(item, index) in hotelList"
               :key="index">
            <div class="hotelname">{{ item.unitCode || '' }}</div>
            <div class="username">{{ item.userCode }}</div>
          </div>
          <div class="centerIn" style="padding-top: 70px;" v-if="hotelList.length">
            <mt-button type="primary" size='large' @click='goLoginLYD'>{{ $t('login_login') }}</mt-button>
          </div>

          <div class="no-hotel" v-if="!loadingLVD && !hotelList.length">
            暂无酒店，请联系管理员
          </div>
        </div>
      </template>


      <template v-else>
        <div v-show="showLoginForm">
          <div class="loginForm" @click='goAnchor' id="input-text-box">
            <mt-field :placeholder="$t('login_hotelCode')" v-model="formOption.hotelCode"></mt-field>
            <mt-field :placeholder="$t('login_username')" v-model="formOption.username"></mt-field>
            <mt-field :placeholder="$t('login_password')" type="password" v-if="formOption.password.length < 100"
                      v-model="formOption.password"></mt-field>
            <mt-field :placeholder="$t('login_password')" type="text" v-else @input.native="formOption.password=''"
                      v-model="vsave"></mt-field>
          </div>
          <div class="centerIn">
            <mt-button type="primary" size='large' @click='login'>{{ $t('login_login') }}</mt-button>
          </div>
          <div class="remember">
            <mt-checklist v-model="value" :options="[$t('login_pleseRemember')]">
            </mt-checklist>
          </div>
          <div class="only-code" v-if="uuid" @click="showOnlyCode">
            <p>{{ $t('login_only_code') }}</p>
          </div>

          <div class="vue-select">
            <p @click="changeSelectVisibility" v-bind:class="{isOpen:selectHelpVisibility }">
              <span>{{ curLanguage }}</span>
              <i class="mint-cell-allow-down"></i>
            </p>
            <ul v-show="selectHelpVisibility">
              <li @click="changeLanguage(item)" :key="item.code" v-for="item in options">{{ item.value }}</li>
            </ul>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  Toast, Indicator
} from "mint-ui";
import {
  rsalogin
} from "../../assets/js/RSA_Stripped.js";
import {MessageBox} from "mint-ui";
import moment from 'moment'
import {
  openAuthMiniApp
} from 'dingtalk-design-libs/biz/openAuthMiniApp';

import * as dd from 'dingtalk-jsapi';

function $setIsOpera() {
  localStorage.setItem('isOperaHotel', 'yes')
}

function $setIsNotOpera() {
  localStorage.setItem('isOperaHotel', 'no')
}

var platWebPmsUrl = 'https://api.ihotel.cn/s/url/'

export default {
  data() {
    return {
      formOption: !!localStorage.LoginOption ?
        JSON.parse(localStorage.LoginOption) :
        {
          hotelCode: "",
          username: "",
          password: ""
        },
      value: ["记住账号密码"],
      logo: './static/images/GClogo.png',
      backgroundType: {
        background: "url('./static/images/loginbg.jpg')",
        height: "100%",
        "background-size": "cover"
      },
      vsave: this.$t('login_saved_Password'),
      selectedOption: localStorage.language || "zh_CN",
      selectHelpVisibility: false,
      curLanguage: "",
      options: [{
        code: "zh_CN",
        value: "简体中文"
      },
        {
          code: "zh_TW",
          value: "繁体中文"
        },
        {
          code: "en_US",
          value: "English"
        }
      ],

      //  钉钉登录
      showLoginForm: !this.$isDingTalk, // 绿云钉的话，还是直接展示登录框，普通钉钉就走老的钉钉登录逻辑
      isNotBindDingDing: true,
      code: '',
      userId: "",
      currentHotelCode: '',
      uuid: '',


      showSelectHotel: this.$isDingTalk && this.$isLD,
      // hotelList: [{
      //   unitCode: 'GCBZ',
      //   userCode: 'ADMIN',
      // },{
      //   unitCode: 'GCBZG',
      //   userCode: "ADMIN"
      // }],
      hotelList: [],
      loadingLVD: true,
      currentHotel: {}
    };
  },
  mounted() {
    if (this.$route.query.jwtToken != null) {
      localStorage.setItem("JWT_TOKEN", this.$route.query.jwtToken);
      // 判断酒店是否为 opera
      let path = this.$getIsOpera() ? '/opera/' : '/'
      this.$router.replace({
        path
      });
      return;
    }

    // 从 iwork调过来，token=ifdjoaifjao
    if (this.$route.query.token != null) {
      var a = this.$route.query.token
      this.doAutoLoginByToken(a)
      return;
    }

    for (var i = 0; i < this.options.length; i++) {
      if (this.options[i].code == this.selectedOption) {
        this.curLanguage = this.options[i].value;
        break;
      }
    }
    this.backgroundType.background = "url(./static/images/loginbg.jpg)";

    // this.hotelList =  []
    // this.loadingLVD = false
    // return
    if (this.$isDingTalk) { // 钉钉h5版本触发的逻辑
      if (this.$isLD) {
        this.getOldLDAuthCode() // 静默授权， 先静默授权，假如静默授权没手机号，就走显示授权
      } else {
        this.getAuthCode()
        // this.getUUID() // 这里拿钉钉用户手机mac,一直都没用到过
      }
    }
  },
  methods: {
    getHotelUrl(hotelCode, setdefault, callback) {
      var self = this
      var afterFix = '_MOBILEPMS?'
      var url = platWebPmsUrl + hotelCode + afterFix + new Date().getTime()

      self.$http.get(url).then(res => {
        var data = res.data || {}
        try {
          if (data.code == 200) {
            $setIsOpera()
            self.getOperaUrl(hotelCode, setdefault, true)
          } else if (data.code != 0) {
            self.msg2(data.msg)
            localStorage.removeItem('con_web_url')
          } else {
            // 成功获取到服务器地址，保存到cookie中
            // url == '0' 的话就是 opera
            if (data.data[0] && data.data[0].url && data.data[0].url == '0') {
              $setIsOpera()
              self.getOperaUrl(hotelCode, setdefault, true)
            } else {
              $setIsNotOpera()
              var url = data.data[0].url
              var urls = url.split(';')
              var murl = urls[2]
              localStorage.setItem('hotelGroupCode', urls[3])
              localStorage.setItem(data.data[0].name, murl)

              if (setdefault) {
                localStorage.setItem('con_web_url', murl)
              }

              if (murl && callback) {
                callback(murl, urls[3])
              }
            }
          }
        } catch (error) {
          $setIsNotOpera()
          self.msg2(error)
        }
      })
    },

    getOperaUrl(hotelCode, setdefault) {
      var self = this
      var afterFix = '_MOBILEOPERA?'
      var url = platWebPmsUrl + hotelCode + afterFix + new Date().getTime()

      self.$http.get(url).then(res => {
        var data = res.data || {}
        try {
          if (data.code == 200) {
            self.msg2('获取链接失败o')
            localStorage.removeItem('con_web_url')
          } else if (data.code != 0) {
            self.msg2(data.msg)
            localStorage.removeItem('con_web_url')
          } else {
            // 成功获取到服务器地址，保存到cookie中
            var url = data.data[0].url
            var urls = url.split('|')
            var murl = urls[6]
            localStorage.setItem('hotelGroupCode', urls[5])
            localStorage.setItem(data.data[0].name, murl)
            if (setdefault) {
              localStorage.setItem('con_web_url', murl)
            }
          }
        } catch (error) {
          self.msg2(error)
        }
      })
    },


    unserialize(url) {
      var parts = url.split("&");
      var json = {};
      parts.forEach(function (item) {
        if (item.indexOf("=") > -1) {
          var itemArray = item.split("=");
          json[itemArray[0]] = itemArray[1];
        }
      });
      return json;
    },

    doAutoLoginByToken(token) {
      var self = this
      var decoded = jwt_decode(token);
      var extendAttributes = decoded.extendAttributes || ''
      var exObj = this.unserialize(extendAttributes)
      var hotelCode = exObj.hotelCode || exObj.hotelGroupCode || ''
      var username = decoded.sub || ''
      localStorage.setItem('hotelCode', hotelCode)
      localStorage.setItem('username', username)
      this.getHotelUrl(hotelCode, true, callbackAutoLogin);

      var postData = {
        token: token,
        mac: localStorage.getItem('hbuilderXNewUUID') || '' // 3.3.0 HX打包之后
      };

      function callbackAutoLogin(con_web_url, hotelGroupCode) {
        // con_web_url = 'http://localhost:9999'
        // con_web_url = 'http://192.168.1.195:8080'
        self.$http.post(con_web_url + "/mobilepmsapi/user/uniteLoginAuto", postData).then(res => {
          var data = res.data || {}
          if (data.result == 0) {
            self.saveLoginInfo(hotelCode, username);
            var jwtoken = data.retVal;
            self.doLogin(jwtoken, con_web_url, hotelCode)
          } else {
            self.msg2('登录失败1' + data.msg)
          }
        })
      }
    },
//记住账户信息
    saveLoginInfo(hotelCode, username) {
      localStorage.setItem('hotelCode', hotelCode)
      localStorage.setItem('username', username)

      var postForm = {
        hotelCode,
        username,
      }
      localStorage.setItem('LoginOption', JSON.stringify(postForm))
    },


    doLogin(token, url, hotelCode) {
      localStorage.removeItem("currentShift"); // 登录的时候，删除房态详情中保存的当前班次信息
      localStorage.removeItem("fangTSearchOption"); // 登录的时候，房态的搜索情况
      localStorage.removeItem("cateringOrderSearchOptions"); // 登录的时候，餐饮订单的搜索情况

      localStorage.setItem("JWT_TOKEN", token);
      localStorage.setItem("con_web_url", url);
      localStorage.setItem("language", "zh_CN");
      this.formOption.hotelCode = hotelCode
      this.judgeIsOpera()
    },


// 普通钉钉，明宇之类的专属钉钉h5版本授权
    getAuthCode() {
      const self = this
      dd.runtime.permission.requestAuthCode({
        corpId: self.$corpId,
        onSuccess: function (result) {
          self.code = result.code || ''
          if (result.code) {
            self.getUserId(result.code)
          }
        },
        onFail: function (err) {
          self.showLoginForm = true
          // this.msg2(JSON.stringify(err, null, 4))
        }
      });
    },


    /* 绿云钉模块 begin */

    // 静默授权，如果没手机号，就走显示授权，有手机号就直接登录
    getOldLDAuthCode() {
      const self = this
      var corpId = self.getQueryVariable('corpId');
      localStorage.setItem('corpId', corpId)
      dd.runtime.permission.requestAuthCode({
        corpId: corpId,
        onSuccess: function (result) {
          if (result.code) {
            self.getOldInfo(corpId, result.code)
          }
        },
        onFail: function (err) {
          self.msg2(JSON.stringify(err, null, 4))
        }
      });
    },

    getOldInfo(corpId, authCode) {
      var self = this
      self.$http.post(`/mobilepmsapi/dingding/queryAuthNoExternal`, {
        corpId: corpId,
        authCode: authCode,
        appCode: window.$isLDTest ? 'MIHOTEL-TEST' : 'MIHOTEL'
      }).then(res => {
        // alert('静默授权查询信息queryAuthNoExternal: ' + JSON.stringify(res.data, null , 4))
        var retVal = res.data.retVal || {}
        if (res.data.result == 0) {
          if (retVal.mobile) { // 静默授权没有手机号，就走显示授权
            self.hotelList = retVal.resultDetailDtos || []
            if (self.hotelList.length == 1) {
              self.currentHotel = self.hotelList[0] || {}
              self.goLoginLYD()
            }
            self.loadingLVD = false
          } else {
            self.getLDAuthCode()
          }
        } else if (res.data.result == -1) {
          self.getLDAuthCode()
        } else {
          self.loadingLVD = false
          self.msg2(res.data.msg)
        }
      });
    },

    // 显示授权拿手机号
    getLDAuthCode() {
      var self = this
      var corpId = self.getQueryVariable('corpId');
      // alert(window.location.href + ',显示授权：corpId = ' + corpId)
      localStorage.setItem('corpId', corpId)
      dd.ready(function () {
        openAuthMiniApp({
          panelHeight: 'percent75',
          path: 'pages/home/home', //不要改,这里是小程序dingwlanwvdmrtjjwdmd下的一个页面地址
          extraData: {
            // 应用ID(唯一标识) SuiteKey
            clientId: window.$isLDTest ? 'suiteeensqv6wyunhmm5e' : 'suiteb2hbi7wcze95pmk4', // mihotel绿云钉suiteKey,写死https://open-dev.dingtalk.com/fe/app#/appMgr/provider/h5/127730/1
            rpcScope: 'Contact.User.Read',
            fieldScope: 'Contact.User.mobile',
            type: 0,
            ext: JSON.stringify({}),
            from: 'mihotel'
          }
        }).then((info) => {
          // 拿到code之后获取token，然后拿到用户用户信息等
          let result = info.result
          if (result) {
            self.getPhoneInfo(corpId, result.authCode)
          } else {
            self.msg2('钉钉授权失败')
          }
        })
      });

      dd.error(function (err) {
        alert('dd error: ' + JSON.stringify(err));
      });
    },

    // 显示授权之后的请求用户信息
    getPhoneInfo(corpId, authCode) {
      var self = this
      self.$http.post(`/mobilepmsapi/dingding/queryAuthLvyunDing`, {
        corpId: corpId,
        authCode: authCode,
        appCode: window.$isLDTest ? 'MIHOTEL-TEST' : 'MIHOTEL'
      }).then(res => {
        // alert('显示授权成功后：queryAuthLvyunDing: ' + JSON.stringify(res))
        if (res.data.result == 0) {
          var retVal = res.data.retVal || {}
          self.hotelList = retVal.resultDetailDtos || []
          if (self.hotelList.length == 1) {
            self.currentHotel = self.hotelList[0] || {}
            self.goLoginLYD()
          }
        } else {
          self.msg2(res.data.msg)
        }
        self.loadingLVD = false
      });
    },

    selectHotel(item) {
      this.currentHotel = item
    },

    // 最后的登录
    goLoginLYD() {
      var self = this
      var item = this.currentHotel || {}
      if (!item.unitCode) {
        this.msg2('请选择登录账号')
        return
      }
      self.$http.post(`/mobilepmsapi/dingding/loginAppForLvyunDing`, {
        unitCode: item.unitCode,
        userCode: item.userCode
      }).then(res => {
        self.formOption.hotelCode = item.unitCode
        if (res.data.result == 0) {
          //全局token
          localStorage.setItem("JWT_TOKEN", res.data.retVal);
          localStorage.removeItem('currentShift') // 清空房态详情中用到的当前班次信息
          localStorage.removeItem('currentLichengCode') // 清空licheng判断用的酒店代码
          localStorage.removeItem('isLiCheng') // 清空licheng判断用的酒店代码
          // 判断酒店是否为 opera
          this.judgeIsOpera()
        } else {
          this.msg2(res.data.msg)
        }
      });
    },

    /* 绿云钉模块 end */

    getUserId(code) {
      const self = this
      this.$http.get(`/mobilepmsapi/dingding/getInternalUserId?authCode=${code}`).then(res => {
        if (res.data.result == 0) {
          let data = res.data || {}
          let userId = data.retVal || ''
          if (userId) {
            self.userId = userId
            self.judgeIsBindDingDing()
          }
        } else {
          self.showLoginForm = true
          // this.msg2(res.data.msg)
        }
      });
    },

    judgeIsBindDingDing() {
      const self = this
      this.$http.get(`/mobilepmsapi/dingding/isBind?userId=${this.userId}&authCorpId=${this.$corpId}`).then(res => {
        if (res.data.result == 0) {
          if (res.data.retVal == 'isNotBindDingDing') {
            this.isNotBindDingDing = true
            self.showLoginForm = true
          } else {
            this.currentHotelCode = res.data.retVal
            self.showLoginForm = false
            this.isNotBindDingDing = false
            this.doLoginByDingDing()
          }
        } else {
          self.showLoginForm = true
          this.msg2(res.data.msg)
        }
      });
    },

    doLoginByDingDing() {
      const self = this
      let userId = this.userId
      Indicator.open('钉钉账号登录中...')
      this.$http.get(`/mobilepmsapi/dingding/loginApp?userId=${userId}&authCorpId=${this.$corpId}`).then(res => {
        if (res.data.result == 0) {
          setTimeout(() => {
            Indicator.close()
          }, 1000)
          //全局token
          localStorage.setItem("JWT_TOKEN", res.data.retVal);
          localStorage.removeItem('currentShift') // 清空房态详情中用到的当前班次信息
          // 判断酒店是否为 opera
          self.judgeIsOpera()
        } else {
          Indicator.close()
          self.showLoginForm = true
        }
      });
    },

    doBindDingDing() {
      const self = this
      let formOption = this.formOption || {}
      this.$http.post(`/mobilepmsapi/dingding/bindApp`, {
        hotelCode: formOption.hotelCode,
        username: formOption.username,
        password: formOption.password,
        openId: this.userId,
        authCorpId: this.$corpId
      }).then(res => {
        if (res.data.result == 0) {

        } else {
          // this.msg2(res.data.msg)
        }
      });
    },

    changeSelectVisibility() {
      this.selectHelpVisibility = !this.selectHelpVisibility;
    },
    changeLanguage(value) {
      localStorage.language = value.code;
      this.$i18n.locale = value.code;
      this.curLanguage = value.value;
      this.selectHelpVisibility = false;
      localStorage.removeItem("myList");
      localStorage.removeItem("page");
    },
    test() {
      this.$http.post('/api/app/sso/checkTicket', {
        ticket: '206c767f28774f13bd024d61edfcb9c7',
        reqTimeStr: moment().format("YYYY-MM-DD HH:mm:ss")
      }).then(res => {
        // code: 1
        // extInfo: "{\"hotelCode\":\"gcbz\"}"
        // sign: "50b4217c09bc4c21857aaf99450e2cc2"
        // userInfo: "{\"realName\":\"集团租赁经办人01\",\"userCode\":\"admin\"}"
      });
    },
    login() {
      // this.test()
      // return
      // this.$http.post('/mobilepmsapi/user/loginForRongTong', {
      //   hotelCode: "RTLYG",
      //   username: "ADMIN",
      // }).then(res => {
      //   if (res.data.result == 0) {
      //     //全局token
      //     localStorage.setItem("JWT_TOKEN", res.data.retVal);
      //     localStorage.removeItem('currentShift') // 清空房态详情中用到的当前班次信息
      //     localStorage.removeItem('currentLichengCode') // 清空licheng判断用的酒店代码
      //     localStorage.removeItem('isLiCheng') // 清空licheng判断用的酒店代码
      //
      //     // 判断酒店是否为 opera
      //     this.judgeIsOpera()
      //   } else {
      //     this.msg2(res.data.msg)
      //   }
      // });
      // return
      var errorMsg = {
        hotelCode: this.$t('login_hotelCode_Not_Empty'),
        username: this.$t('login_username_Not_Empty'),
        password: this.$t('login_password_Not_Empty')
      };
      let mobileOrderPassword = this.formOption.password
      localStorage.setItem("mobileOrderPassword", mobileOrderPassword);

      var errors = "";
      var postForm = _.transform(this.formOption, (result, n, key) => {
        if (!n && _.isEmpty(errors)) {
          errors = errorMsg[key];
          return;
        } else {
          if (key != "password") {
            result[key] = n.toUpperCase();
          } else {
            result[key] = rsalogin(n);
          }
        }
      });
      if (!_.isEmpty(postForm) && Object.keys(postForm).length == 3) {
        console.log(_.isEmpty(this.value));
        if (_.isEmpty(this.value)) {
          localStorage.removeItem("LoginOption");
        } else {
          localStorage.setItem("LoginOption", JSON.stringify(postForm));
        }

        if (this.uuid) {
          postForm.mac = this.uuid
        }

        this.$http.post('/mobilepmsapi/user/login', postForm).then(res => {
          if (res.data.result == 0) {
            //全局token
            localStorage.setItem("JWT_TOKEN", res.data.retVal);
            localStorage.removeItem('currentShift') // 清空房态详情中用到的当前班次信息
            localStorage.removeItem('currentLichengCode') // 清空licheng判断用的酒店代码
            localStorage.removeItem('isLiCheng') // 清空licheng判断用的酒店代码

            // 判断酒店是否为 opera
            this.judgeIsOpera()
            if (this.isNotBindDingDing) {
              this.doBindDingDing()
            }
          } else {
            this.msg2(res.data.msg)
          }
        });
      } else {
        this.msg2(errors)
      }
    },

    judgeIsOpera() {
      let hotelCode = this.formOption.hotelCode || ''
      this.$http.post('/mobilepmsapi/sysOptions/findOptionIsOpera', {
        hotelcode: hotelCode.toUpperCase(),
        noErrorToast: true
      }).then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal
          let isOpera = retVal == 'Opera'
          if (isOpera) {
            this.$setIsOpera()
          } else {
            this.$setIsNotOpera()
          }
          let path = isOpera ? '/opera/' : '/'
          this.$router.replace({
            path
          });
        } else {
          this.$setIsNotOpera()
          this.$router.replace({
            path: '/'
          });
        }
      }).catch((res) => {
        this.$setIsNotOpera()
        this.$router.replace({
          path: '/'
        });
      })
    },

    goAnchor(event) {
      var inputTextBox = document.getElementById("input-text-box");

      setInterval(function () {
        inputTextBox.scrollIntoView(true);
      }, 200);
    },

    showOnlyCode() {
      const self = this
      MessageBox({
        title: self.$t('login_only_code'),
        message: self.uuid || '',
        showCancelButton: true,
        confirmButtonText: self.$t('Copy'),
        cancelButtonText: self.$t('cancel'),
      }).then((action) => {
        if (action == 'confirm') {
          dd.biz.clipboardData.setData({
            text: self.uuid, //要复制粘贴板的内容
            onSuccess: function (result) {
              /**/
              self.msg2(self.$t('CopySuccess'))
            },
            onFail: function () {
            }
          })
        }
      });
    },

    getUUID() {
      const self = this
      let tempUrlArr = location.href.split('#') || []
      let tempUrl = tempUrlArr[0] || ''
      this.$http.get('/mobilepmsapi/dingding/getJsApiByDingDing?authCorpId=' + this.$corpId + '&url=' + tempUrl).then(res => {
        let retVal = res.data.retVal || {}
        dd.config({
          agentId: this.$agentId, // 必填，微应用ID
          corpId: this.$corpId,//必填，企业ID
          timeStamp: retVal.timeStamp, // 必填，生成签名的时间戳
          nonceStr: retVal.nonceStr, // 必填，生成签名的随机串
          signature: retVal.signature, // 必填，签名
          type: 0,   //选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
          jsApiList: [
            'runtime.info',
            'biz.contact.choose',
            'device.notification.confirm',
            'device.notification.alert',
            'device.notification.prompt',
            'device.base.getUUID',
            'biz.clipboardData.setData',
            'biz.ding.post',
            'biz.util.openLink',
          ] // 必填，需要使用的jsapi列表，注意：不要带dd。
        });
        dd.ready(function () {
          dd.device.base.getUUID({
            onSuccess: function (data) {
              self.uuid = data.uuid || ''
            },
            onFail: function (err) {
            }
          });
        })
        dd.error((error) => {
        });
      }).catch((res) => {
      })
    },

    getQueryVariable(variable) {
      // return 'ding013ea2dcb2eb81a5f2c783f7214b6d69'
      var href = window.location.href;
      var temp = href.substring(href.indexOf('?') + 1);
      let query = temp.substring(temp.indexOf('ding'));
      var final = ''
      if (query && (query.indexOf('ding') > -1)) {
        final = query
        localStorage.setItem('lastCorpId', query)
        // alert('lastCorpId:' + query)
      } else {
        final = localStorage.getItem('lastCorpId') || ''
      }
      if (final) {
        return final
      } else {
        this.msg('corpId异常,请退出重进：' + href)
        return ''
      }
    }
  },
};
</script>

<style lang="less">
.login {
  overflow: hidden;


  ::-webkit-input-placeholder {
    /* WebKit browsers */
    font-size: 0.4rem;
    color: #fff;
    text-decoration: none;
  }

  .mint-cell-wrapper {
    background: none;
    padding: 0;
    overflow: visible;
  }

  .loginHeader {
    margin: 2.2rem 0 1.5rem 1.2rem;
    color: #fff;
    width: 7.5rem;
    text-align: center;

    img {
      width: 5.6rem;
    }

    span {
      vertical-align: top;
      position: relative;
      top: 0.1rem;
    }

    .point {
      font-size: 1rem;
      top: 0.5rem;
    }

    .pms {
      font-size: 0.6rem;
      top: 0.8rem;
      left: 0.3rem;
    }

    .iconfont {
      font-size: 1.6rem;
      color: #fff;
    }
  }

  .hotel-list {
    padding: 30px;
    padding-top: 0;
    box-sizing: border-box;
    max-height: 60%;
    overflow-y: scroll;

    .no-hotel {
      font-size: 20px;
      text-align: center;
      color: #fff;
      margin-top: 30px;
    }

    .hotel-list-item {
      border: 1px solid #fff;
      margin-bottom: 20px;
      border-radius: 10px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 18px;

      &.active {
        background: rgba(255, 255, 255, 0.4);
      }

      &:active {
        background: rgba(255, 255, 255, 0.2);
      }

      .hotelname {

      }

      .username {

      }
    }
  }

  .mintui-field-error {
    font-size: 0.5rem;
    margin-right: 0.2rem;
  }

  .mint-cell-value {
    display: block;
    position: relative;
  }

  .mint-field-core {
    text-align: center;
    height: 1.2rem;
    opacity: 0.8;
    font-size: 0.4rem;
    background: none;
    width: 80%;
    margin: 0 0.73rem;
    color: #fff;
    border: none;
    text-transform: uppercase;
    text-decoration: none;
    outline: none;
  }

  .mint-field-clear {
    position: absolute;
    right: 0;
  }

  .mint-cell {
    color: #fff;
    width: 7.3rem;
    height: 1.2rem;

    margin: 0 auto;
    margin-top: 0.45rem;
    font-size: 0.5rem;
    background: none;
  }

  .mint-cell:last-child {
    background: none;
  }

  .mint-cell-wrapper {
    border: 1px solid #f4f4f4;
    border-radius: 0.6rem;

    @media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1) {
      border: 2px solid #f4f4f4;
    }
  }

  .centerIn {
    width: 7.3rem;
    margin: 0 auto;
    margin-top: 0.45rem;

    button {
      height: 1.2rem;
      font-size: 0.46rem;
      background: #f6a623;
      background-image: linear-gradient(90deg, #f6a129 0%, #ff6e61 98%);
      border-radius: 100px;
    }
  }

  .remember {
    padding-bottom: 20px;

    .mint-cell-wrapper {
      border: none;
      border-radius: 0;
      background: none;
    }

    .mint-cell {
      background: none;
      border: none;
    }

    .mint-checkbox-core {
      border-radius: 0.06rem;
      width: 0.3rem;
      height: 0.3rem;
      margin-right: 0.1rem;
    }

    .mint-checkbox-core::after {
      width: 0.1rem;
      height: 0.1rem;
      top: 0.06rem;
      left: 0.08rem;
      transform: rotate(45deg) scale(1, 2.2) !important;
      border-width: 1px !important;

      @media only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1) {
        border-width: 2px !important;
      }
    }

    .mint-checkbox-label {
      font-size: 0.4rem;
    }

    .mint-checkbox-input:checked + .mint-checkbox-core {
      border-color: #f89635;
      background: #fff;
    }

    .mint-checkbox-input:checked + .mint-checkbox-core::after {
      border-color: #f89635;
    }
  }
}

.only-code {
  width: 2.5rem;
  float: left;
  color: #fff;
  position: relative;
  font-size: 0.35rem;
  margin-right: 10px;

  p {
    line-height: 30px;
    height: 30px;
    border-radius: 5px 5px 0 0;
    padding: 0 0 0 18px;
  }
}

.mint-msgbox-message {
  word-break: break-all;
}

.vue-select {
  width: 2.5rem;
  float: right;
  color: #fff;
  position: relative;
  font-size: 0.35rem;
  margin-right: 10px;

  p {
    line-height: 30px;
    height: 30px;
    border-radius: 5px 5px 0 0;
    padding: 0 0 0 18px;

    .mint-cell-allow-down {
      display: inline-block;
    }

    .mint-cell-allow-down:after {
      border: solid 2px #c8c8cd;
      border-bottom-width: 0;
      border-left-width: 0;
      content: " ";
      float: left;
      margin: 8px 0 0 5px;
      width: 5px;
      height: 5px;
      -webkit-transform: translateY(-50%) rotate(45deg);
      transform: translateY(-50%) rotate(135deg);
    }

    i {
      font-size: 0.4rem;
      position: absolute;
      right: 8px;
      top: 5px;
    }
  }

  p.isOpen {
    background: #fff;
    color: #999;

  }

  ul {
    background: #fff;
    color: #000;
    border-radius: 0 0 5px 5px;
    padding: 10px 0 0 18px;

    li {
      line-height: 30px;
      height: 30px;
    }
  }
}

.vue-select:hover {
  ul {
    display: block;
  }
}

.language {
  position: relative;

  .language-select {
    float: right;
    margin: 0 30px 0 0;
    color: #fff;
  }

  .mint-cell-allow-down {
    float: left;
    margin-left: -10px;
  }

  .mint-cell-allow-down:after {
    border: solid 2px #c8c8cd;
    border-bottom-width: 0;
    border-left-width: 0;
    content: " ";
    top: 50%;
    right: 20px;
    position: absolute;
    width: 5px;
    height: 5px;
    -webkit-transform: translateY(-50%) rotate(45deg);
    transform: translateY(-50%) rotate(135deg);
  }
}

/*清除浮动代码*/
.clearfloat:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}

.clearfloat {
  zoom: 1;
}

.mint-toast {
  border-radius: 0.2rem;

  .iconfont {
    font-size: 2.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?ab00be5a